import InboxIcon from "@mui/icons-material/MoveToInbox";
import DraftsIcon from "@mui/icons-material/Drafts";
// import SendIcon from "@mui/icons-material/Send";
// import { domain } from "../../constants/generalConstant";

export const headerData = [
  {
    id: 1,
    title: "Home",
    subTitle: "Return Home",
    items: [
      {
        id: 11,
        label: "Explore",
        url: "/",
      },
    ],
    icon: <InboxIcon />,
  },
  {
    id: 2,
    title: "About Us",
    subTitle: "Personal & Business",
    items: [
      {
        id: 11,
        label: "Explore",
        url: "/about-us",
      },
    ],
    icon: <InboxIcon />,
  },
  {
    id: 3,
    title: "Services",
    subTitle: "Learn more about our services",
    items: [
      {
        id: 12,
        label: "Explore",
        url: "/service",
      },
    ],
    icon: <DraftsIcon />,
  },
  {
    id: 4,
    title: `Contact Us`,
    subTitle: "Let's help ",
    items: [
      {
        id: 12,
        label: "Explore",
        url: "/contact-us",
      },
    ],
    icon: <DraftsIcon />,
  },
];

export const faqData = [
  {
    id: "panel1",
    title: "General settings",
    subtitle: "What Is a Tracking Number & Where Can I Find It?",
    content:
      "A tracking number or ID is a combination of numbers and possibly letters that uniquely identifies your shipment for national or international tracking. Usually, the shipper or online shop is able to provide the tracking number or ID. If you have ordered a product in an online shop, the confirmation email or shipment tracking notification often contains the tracking number or ID. If not, please contact your shipper or online shop.",
  },
  {
    id: "panel2",
    title: "Users",
    subtitle: "When will my tracking information appear?",
    content:
      "Tracking events usually appear 24-48 hours after receiving the Track and Trace ID. In general, once the shipment has reached our facility, a tracking event will appear.",
  },
  {
    id: "panel3",
    title: "Advanced settings",
    subtitle: "Why is my tracking number/ID not working?",
    content:
      "Please make sure you entered the correct tracking number in the correct format: Check for minimum length of 5 characters, and if there are any special characters in your input. Tab, comma, space and semicolon are understood as separators between several tracking IDs. If your tracking ID is not working, please contact your shipper or online shop.",
  },
  {
    id: "panel4",
    title: "Personal data",
    subtitle:
      "If I do not have my tracking number, is it still possible to track my shipment?",
    content:
      "If you do not have a tracking number, we advise you to contact your shipper. However, if you have other shipping reference numbers, they may work using shipment tracking systems of the specific business unit in charge of the shipment (for example: Shippersroute Express or Shippersroute Freight). ",
  },
];
